import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
    comboProduct,
    initialState,
} from 'app/core/models/slice/combo/comboProduct'
import { isObject, isArray } from 'lodash'

const slice = createSlice({
    name: 'comboProduct',
    initialState,
    reducers: {
        //콤보 초기화
        clearComboProduct: (state) => {
            Object.keys(initialState).map((key1) => {
                if (isObject(state[key1])) {
                    state[key1] = {}
                } else if (isArray(state[key1])) {
                    state[key1] = []
                } else {
                    state[key1] = ''
                }
            })
        },
        //콤보 정보 저장
        setComboProduct: (state, action: PayloadAction<comboProduct>) => {
            state = { ...action.payload }
        },
        //관련상품라인코드 저장
        setRltdPdlnCd: (state, action: PayloadAction<string>) => {
            state.rltdPdlnCd = action.payload
        },
        //관련상품그룹코드 저장
        setRltdPdgrCd: (state, action: PayloadAction<string>) => {
            state.rltdPdgrCd = action.payload
        },
        //관련상품템플릿코드 수정
        setRltdPdtmCd: (state, action: PayloadAction<string>) => {
            state.rltdPdtmCd = action.payload
        },
        //관련상품코드 수정
        setRltdPdcd: (state, action: PayloadAction<string>) => {
            state.rltdPdcd = action.payload
        },
        //관련상품명 수정
        setRltdPdm: (state, action: PayloadAction<string>) => {
            state.rltdPdm = action.payload
        },
        //비대면실명확인진행상태코드 수정
        setNofcRlncPgrsScd02: (state, action: PayloadAction<string>) => {
            state.nofcRlncPgrsScd02 = action.payload
        },
        setComboProductArr: (state, action: PayloadAction<any>) => {
            action.payload.map((joinArr) => {
                state[joinArr.key] = joinArr.value
            })
        },
        setComboProductObArr: (state, action: PayloadAction<any>) => {
            Object.keys(action.payload).map((key) => {
                Object.keys(initialState).map((key1) => {
                    if (
                        key1 === key &&
                        action.payload[key] !== '' &&
                        action.payload[key] !== undefined &&
                        action.payload[key] !== null
                    ) {
                        state[key] = action.payload[key]
                    }
                })
            })
        },
    },
})

export const {
    clearComboProduct,
    setComboProduct,
    setRltdPdlnCd,
    setRltdPdgrCd,
    setRltdPdtmCd,
    setRltdPdcd,
    setRltdPdm,
    setNofcRlncPgrsScd02,
    setComboProductArr,
    setComboProductObArr,
} = slice.actions

export default slice.reducer
